import * as z from "zod";
import { gql } from "graphql-request";

import { SysSchema, SysFragment } from "./sys";
import { TargetingSchema, TargetingFragment } from "./targeting";
import { RelatedMediaSchema, RelatedMediaFragment } from "./relatedMedia";
import {
  LocalizedSpotlightSchema,
  LocalizedSpotlightFragment,
} from "./newsEntryTypes/localizedSpotlight";
import {
  CarouselEventPollEntrySchema,
  CarouselEventPollEntryFragment,
} from "./newsEntryTypes/carouselEventPollEntry";
import {
  CarouselEventProgressTrackerEntrySchema,
  CarouselEventProgressTrackerEntryFragment,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";

export const SpotlightSchema = z.object({
  __typename: z.literal("Spotlight"),
  sys: SysSchema,
  sortDate: z.string().nullable(),
  newUntil: z.string().nullable(),
  size: z.enum(["small", "medium", "large"]).nullable(),
  video: z.string().nullable(),
  enableVideoSound: z.boolean().nullable().default(false),
  targeting: TargetingSchema.nullable(),
  relatedMedia: RelatedMediaSchema.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      LocalizedSpotlightSchema,
      CarouselEventPollEntrySchema,
      CarouselEventProgressTrackerEntrySchema,
    ])
    .nullish(),
});

export const Spotlight = SpotlightSchema;
export type Spotlight = z.infer<typeof SpotlightSchema>;

export const SpotlightFragment = gql`
  fragment SpotlightFragment on Spotlight {
    __typename
    sys {
      ...SysFragment
    }
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    newUntil
    sortDate
    size
    video
    enableVideoSound
    localized {
      ... on LocalizedSpotlight {
        ...LocalizedSpotlightFragment
      }
      ... on CarouselEventPollEntry {
        ...CarouselEventPollEntryFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }
  ${SysFragment}
  ${LocalizedSpotlightFragment}
  ${CarouselEventPollEntryFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
